import { Illustration, Typography, Wrapper } from '@screentone/core';

import styles from './AlreadyInScratchpadMessage.module.scss';

export const AlreadyInScratchpadMessage = () => (
  <Wrapper padding={{ all: 'lg' }} className={styles.emptyWrapper} data-testid="search-content-dedupe-message">
    <Illustration name="empty" className={styles.emptyImage} />
    <Typography variant="header2" margin={{ top: 'lg', bottom: 'md' }}>
      Already in Scratch Pad
    </Typography>
    <Typography align="center" variant="bodytext">
      This item is already in the <b>Scratch Pad</b>. If you don&apos;t see it, enable it under{' '}
      <b>Settings &gt; Module Enablement</b>.
    </Typography>
  </Wrapper>
);
